import { apiEndpoint } from '@/configs/api/api-configs'
import { reactive } from '@vue/composition-api'

export default function documentModel() {
  const fetchDocumentContainerList = reactive({
    api: `${apiEndpoint.bcrm_platform}/document/container/list`,
    method: 'POST',
    payload: {
      Page: 1,
      Limit: 10,
      Filters: [
      ],
    },
  })

  const fetchDocumentContainerCreate = reactive({
    api: `${apiEndpoint.bcrm_platform}/document/container/Create`,
    method: 'POST',
    payload: {
      Name: '',
    },
  })

  const fetchDocumentContainerEdit = reactive({
    api: `${apiEndpoint.bcrm_platform}/document/container/Edit`,
    method: 'POST',
    payload: {
      Container_Id: 0,
      Name: '',
      Status: true, // true = Inactive , false = Active
    },
  })

  const fetchDocumentContainerDetail = reactive({
    api: `${apiEndpoint.bcrm_platform}/document/container/Detail`,
    method: 'POST',
    payload: {
      Container_Id: 0,
    },
  })

  const fetchDocumentList = reactive({
    api: `${apiEndpoint.bcrm_platform}/document/list`,
    method: 'POST',
    payload: {
      Container_Id: 0,
      FromDate: '',
      FromTime: '',
      ToDate: '',
      ToTime: '',
      Page: 1,
      Limit: 10,
      Filters: [
      ],
    },
  })

  const fetchDocumentDetail = reactive({
    api: `${apiEndpoint.bcrm_platform}/document/detail`,
    method: 'POST',
    payload: {
      DocumentId: 0,
    },
  })

  const fetchDocumentEdit = reactive({
    api: `${apiEndpoint.bcrm_platform}/document/edit`,
    method: 'POST',
    payload: {
      DocumentId: 0,
      DocumentNo: "",
      StoreName : "",
      Name : "",
      MobileNo : "",
      Remark: '',
      Remark2: '',
      ITF_Ref: '',
      ITF_Ref_2: '',
      ITF_ExtraData: '',
      CRM_Point : 0,
      CRM_SpenDing : 0,
      RejectId : 0,
      Reject_Reason :'',
      From_Status: 1,
      To_Status: 5, // 1 pending 5 complete 9 reject
      FormId: 1,
      payload: {
        // point: 10,
        // spending: 100.0,
      },
      Payload_Opts:[],
    },
  })

  const fetchDocumentBi = reactive({
    api: `${apiEndpoint.bcrm_platform}/document/container/bi`,
    method: 'GET',
    payload: {
      Container_Id: 0,
    },
  })

  return {
    fetchDocumentContainerList,
    fetchDocumentContainerCreate,
    fetchDocumentContainerEdit,
    fetchDocumentContainerDetail,
    fetchDocumentList,
    fetchDocumentDetail,
    fetchDocumentEdit,
    fetchDocumentBi
  }
}
